import {
  MEGA_MENU,
  GLOBAL_NAV,
  TOGGLE_SEARCH,
  SET_PROFILE_DATA,
  SET_PROFILE_LOADING,
  SET_RELOGIN,
  SET_MINIAPP,
  SET_BACKENABLED,
  TOGGLE_FILTERS,
  SET_CHECKOUT_LOGIN
} from "../actionTypes/index";
import ajaxService from "../../utils/ajaxServices";
import { setLoadingStatus } from "./commonAction";

export const megaMenu = () => async dispatch => {
  try {
    setLoadingStatus(true, dispatch);
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "getMainMenuMetaData"
    );

    dispatch({ type: MEGA_MENU, payload: result.children });
  } catch (error) {
    setLoadingStatus(false, dispatch);
  } finally {
    setLoadingStatus(false, dispatch);
  }
};

export const globalNav = () => async dispatch => {
  try {
    setLoadingStatus(true, dispatch);
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "getGlobalNavMetaData"
    );

    dispatch({ type: GLOBAL_NAV, payload: result });
  } catch (error) {
    setLoadingStatus(false, dispatch);
  } finally {
    setLoadingStatus(false, dispatch);
  }
};

export const toggleSearch = value => dispatch => {
  dispatch({ type: TOGGLE_SEARCH, payload: value });
};

export const setProfileData = profileInfo => async dispatch => {
  if (
    profileInfo &&
    profileInfo.result &&
    profileInfo.result.magentoProfileResponse[0] &&
    profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0]
  ) {
    const customerInfo = {
      id: profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0]
        .customer_id,
      groupName: profileInfo.result.magentoProfileResponse[0].customerGroupName,
    };

    dispatch({
      type: SET_PROFILE_DATA,
      payload: {
        profile: profileInfo.result.magentoProfileResponse[0].ProfileDetails[0],
        user: true,
        customer: customerInfo,
        oauthTokenDetails:
          profileInfo.result.magentoProfileResponse[0].oauthTokenDetails[0],
        subscriptions:
          profileInfo?.result?.profileSubscriptionResponse?.subscriptions
            ?.subscriptions || [],
      },
    });
  } else {
    dispatch({
      type: SET_PROFILE_DATA,
      payload: {
        profile: null,
        user: false,
        customer: null,
        oauthTokenDetails: null,
        subscriptions: [],
      },
    });
  }
};

export const setProfileLoading = status => async dispatch => {
  dispatch({ type: SET_PROFILE_LOADING, payload: status });
};

export const setReLogin = status => async dispatch => {
  dispatch({ type: SET_RELOGIN, payload: status });
};

export const setMiniApp = status => async dispatch => {
  dispatch({ type: SET_MINIAPP, payload: status });
};

export const setBackEnabled = status => async dispatch => {
  dispatch({ type: SET_BACKENABLED, payload: status });
};

export const toggleFilters = value => dispatch => {
  dispatch({ type: TOGGLE_FILTERS, payload: value });
};

export const setCheckoutLogin = status => async dispatch => {
  dispatch({ type: SET_CHECKOUT_LOGIN, payload: status });
};
